/**
 * COMPETENCIAS · «COMPETICIONES»
 * =============================================================================
 * La fotografía del equipo con el trofeo a pantalla completa, con el texto y la
 * lista encima. Debajo, los cuatro paneles y el cierre.
 */

import { CONFIG } from '../config';
import { PantallaCompleta } from '../componentes/PantallaCompleta';
import { Icono, IconoEnAro, type NombreIcono } from '../componentes/Iconos';
import { Revelar } from '../componentes/Piezas';
import { useIdioma } from '../i18n/useIdioma';

export function Competencias() {
  const { textos } = useIdioma();
  const t = textos.competencias;

  const irA = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <PantallaCompleta
        id="competencias"
        foto={CONFIG.fotos.portadaCompetencias}
        alt={t.fotoAlt}
        etiqueta={t.etiqueta}
        titulo={<span className="oro">{t.titulo1}</span>}
        texto={t.texto}
        /* El trofeo está en la mitad de arriba de la foto. */
        encuadre="50% 30%"
        encuadreMovil="50% 24%"
      >
        <ul className="competencias__lista">
          {t.lista.map((c) => (
            <li className="competencia" key={c.titulo}>
              <IconoEnAro nombre={c.icono as NombreIcono} tam={58} grosorIcono={24} />
              <div>
                <p className="competencia__titulo">{c.titulo}</p>
                <p className="competencia__texto">{c.texto}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className="acciones-fila">
          <button type="button" className="boton boton--marco" onClick={() => irA('informacion')}>
            <span>{t.boton}</span>
            <Icono nombre="flecha" tam={16} />
          </button>
        </div>
      </PantallaCompleta>

      <div className="caja">
        <Revelar>
          <div className="paneles">
            {t.paneles.map((p) => (
              <div className="panel" key={p.titulo}>
                <span className="panel__texto">{p.titulo}</span>
              </div>
            ))}
          </div>
        </Revelar>

        <Revelar>
          <div className="cierre">
            <p className="cierre__texto">
              {t.cierre1}
              <br />
              <span className="cierre__blanco">{t.cierre2}</span>
            </p>
            <p className="cierre__firma">{textos.academia.firma}</p>
          </div>
        </Revelar>
      </div>
    </>
  );
}
